import _ from 'lodash';
import qs from 'qs';

function fromQuery(query) {
  const result = {
    filter: {},
    sorting: {}
  };

  if (query['p']) {
    result.pagination = {
      currentPage: query['p']
    };
  }

  if (query['ex']) {
    result.expandedIds = query['ex'].split(',');
  }

  _.forOwn(query, (value, key) => {
    if (!_.startsWith(key, 'f-')) return;

    result.filter[key.replace('f-', '')] = value;
  });

  _.forOwn(query, (value, key) => {
    if (!_.startsWith(key, 's-')) return;

    result.sorting[key.replace('s-', '')] = value;
  });

  return result;
}

function loadStateFromUrl(history) {
  return fromQuery(qs.parse(history.location.search, {ignoreQueryPrefix: true}));
}

export default loadStateFromUrl;
